const config = {
    id: 2,
    name: "轮播图",
    type: 1,
    module_code: "image_list",
    icon: "icon-tms-image_list",
    font_icon: "&#xe623;",
    style_type: 1,
    link_type: 5,
    link_data: [{}],
    property_data: {
        height: 190,
        padding: 0,
        borderRadius: 0
    }
};

export default config;